// frontend/src/TagSelect.js

import React, { useState, useEffect, useRef } from 'react';
import './TagSelect.css';

function TagSelect({ selectedTags = [], onChange, tags = [], placeholder = "Etiket seçin...", onOpen }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const containerRef = useRef(null);

  // Dropdown açıldığında scroll yap
  const handleToggleDropdown = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    
    // Açılıyorsa
    if (newState) {
      // Parent component'e bildir
      if (onOpen) {
        onOpen();
      }
      
      // Dropdown tam açıldıktan sonra scroll yap
      setTimeout(() => {
        // Dropdown elementini bul
        const dropdownElement = dropdownRef.current?.querySelector('.tag-select-dropdown');
        
        if (dropdownElement) {
          // Modal container'ı bul
          const modalContainer = dropdownElement.closest('.modal-container');
          
          if (modalContainer) {
            // Dropdown'un pozisyonunu hesapla
            const dropdownRect = dropdownElement.getBoundingClientRect();
            const modalRect = modalContainer.getBoundingClientRect();
            
            // Eğer dropdown modal'ın altında kalıyorsa scroll yap
            if (dropdownRect.bottom > modalRect.bottom - 50) {
              const scrollAmount = dropdownRect.bottom - modalRect.bottom + 100;
              
              modalContainer.scrollBy({
                top: scrollAmount,
                behavior: 'smooth'
              });
            }
          }
        }
      }, 150); // Dropdown animasyonu için biraz bekle
    }
  };

  // Dışarı tıklandığında dropdown'ı kapat
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Etiket seç/kaldır
  const toggleTag = (tagId) => {
    const newSelection = selectedTags.includes(tagId)
      ? selectedTags.filter(id => id !== tagId)
      : [...selectedTags, tagId];
    
    onChange(newSelection);
  };

  // Tümünü seç/temizle
  const selectAll = () => {
    onChange(tags.map(tag => tag.id));
  };

  const clearAll = () => {
    onChange([]);
  };

  // Filtrelenmiş etiketler
  const filteredTags = tags.filter(tag =>
    tag.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Seçili etiket bilgilerini al
  const getSelectedTagInfo = () => {
    return tags.filter(tag => selectedTags.includes(tag.id));
  };

  return (
    <div className="tag-select-container" ref={dropdownRef}>
      <div 
        className={`tag-select-input ${isOpen ? 'open' : ''}`}
        onClick={handleToggleDropdown}
      >
        <div className="selected-tags">
          {selectedTags.length === 0 ? (
            <span className="placeholder">{placeholder}</span>
          ) : (
            getSelectedTagInfo().map(tag => (
              <span 
                key={tag.id} 
                className="tag-badge"
                style={{ backgroundColor: tag.color }}
              >
                {tag.name}
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    toggleTag(tag.id);
                  }}
                  className="tag-remove"
                >
                  ×
                </button>
              </span>
            ))
          )}
        </div>
        <div className="tag-select-arrow">
          <svg width="12" height="8" viewBox="0 0 12 8">
            <path d="M1 1l5 5 5-5" stroke="currentColor" strokeWidth="2" fill="none"/>
          </svg>
        </div>
      </div>

      {isOpen && (
        <div className="tag-select-dropdown">
          <div className="tag-select-header">
            <input
              type="text"
              className="tag-search"
              placeholder="Etiket ara..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
            <div className="tag-select-actions">
              <button onClick={selectAll} className="select-all-btn">
                Tümünü Seç
              </button>
              <button onClick={clearAll} className="clear-all-btn">
                Temizle
              </button>
            </div>
          </div>

          <div className="tag-options">
            {filteredTags.length === 0 ? (
              <div className="no-tags">Etiket bulunamadı</div>
            ) : (
              filteredTags.map(tag => (
                <div
                  key={tag.id}
                  className={`tag-option ${selectedTags.includes(tag.id) ? 'selected' : ''}`}
                  onClick={() => toggleTag(tag.id)}
                >
                  <input
                    type="checkbox"
                    checked={selectedTags.includes(tag.id)}
                    onChange={() => {}}
                    className="tag-checkbox"
                  />
                  <span 
                    className="tag-color-dot"
                    style={{ backgroundColor: tag.color }}
                  ></span>
                  <span className="tag-name">{tag.name}</span>
                  {selectedTags.includes(tag.id) && (
                    <span className="tag-check">✓</span>
                  )}
                </div>
              ))
            )}
          </div>

          <div className="tag-select-footer">
            <span className="tag-count">
              {selectedTags.length} / {tags.length} seçili
            </span>
          </div>
        </div>
      )}
    </div>
  );
}

export default TagSelect;